import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ElementRef,
  OnInit,
  OnDestroy,
  HostBinding,
  ChangeDetectorRef,
  Renderer2,
  HostListener,
  ViewChild,
} from '@angular/core';
import { v4 as newGuid } from 'uuid';
import { ModalService } from './modal.service';

export interface IModalComponent {
  modalId: string;
  open(): void;
  close(): void;
}

@Component({
  selector: 'nibtravel-modal',
  templateUrl: './modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalComponent implements IModalComponent, OnInit, OnDestroy {
  private element = this.el.nativeElement;

  @Input() modalId: string = newGuid();
  @Input() headerTitle!: string;
  @Input() closeButtonText!: string;

  /**
   * use this flag if you want to use custom buttons inside footer and hide the close button
   * default value is false - which shows a close button
   */
  @Input() customFooter = false;

  @HostBinding('class') class = 'modal';
  @HostBinding('class.open') isOpen = false;

  @ViewChild('modalDialog')
  modalDialog!: ElementRef;

  constructor(
    private renderer: Renderer2,
    private el: ElementRef,
    private modalService: ModalService,
    private cd: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.renderer.appendChild(document.body, this.element);
    this.modalService.add(this);
  }

  ngOnDestroy(): void {
    this.isOpen = false;
    this.modalService.remove(this.modalId);
  }

  close(): void {
    this.isOpen = false;
    this.cd.markForCheck();
    this.renderer.removeClass(document.body, 'modal-open');
  }

  open(): void {
    this.isOpen = true;
    this.cd.markForCheck();
    this.renderer.addClass(document.body, 'modal-open');
  }

  @HostListener('document:mousedown', ['$event'])
  onOverlayClicked(event: MouseEvent): void {
    if (this.modalDialog !== undefined) {
      const clickOnModalDialog = this.doesClickOnTargetElement(
        event,
        this.modalDialog.nativeElement
      );
      if (!clickOnModalDialog) {
        this.close();
      }
    }
  }

  private doesClickOnTargetElement(
    clickEvent: MouseEvent,
    targetElement: HTMLElement
  ) {
    let clickTarget = clickEvent.target as HTMLElement | null;
    let clickOnHost = true;
    while (clickTarget !== null) {
      clickOnHost = clickTarget === targetElement; // the input
      if (clickOnHost) {
        break;
      }
      clickTarget = clickTarget.parentElement;
    }
    return clickOnHost;
  }
}
